import {Col, Row} from "react-bootstrap";
import {trans} from "../../../../../../translations/translations";

const HungerAdvice3 = () => {
    return (
        <Row className={"response-row"}>
            <Col xs={12} className={"title mb-2"}>
                <p className={"m-0"}>
                    <span className={"me-1"}>{trans('results.answer1.hunger.advice3.title.text1', 'sos')}</span>
                    <span className={"me-1 text-bold"}>{trans('results.answer1.hunger.advice3.title.text2', 'sos')}</span>
                    <span className={"me-1 "}>{trans('results.answer1.hunger.advice3.title.text3', 'sos')}</span>
                    <span className={"me-1 text-pink text-bold"}>{trans('results.answer1.hunger.advice3.title.text4', 'sos')}</span>
                    <span className={"me-1 "}>{trans('results.answer1.hunger.advice3.title.text5', 'sos')}?</span>
                </p>
            </Col>
            <Col xs={12} className={"text-result mb-3"}>
                <p className={"m-0"}>{trans('results.answer1.hunger.advice2.sub.text1', 'sos')}</p>
            </Col>
            <Col xs={12} className={"text-result mb-3"}>
                <p className={"m-0"}>{trans('results.answer1.hunger.advice2.sub.text2', 'sos')}</p>
            </Col>
            <Col xs={12} className={"text-result"}>
                <p className={"m-0"}>{trans('results.answer1.hunger.advice2.sub.text3', 'sos')}</p>
            </Col>
        </Row>
    )
}

export default HungerAdvice3;
